import { z } from "zod";

export const accountSchema = z.object({
  
  email: z.string().email(),
  full_name: z.string().min(1, { message: "this_field_is_required" }),
  national_id: z.string().min(1, { message: "this_field_is_required" }),
  birthday: z.any(),
  sign_up_date: z.any(),
  phone_number: z
    .string()
    .regex(
      new RegExp(
        /(0|\+98)?([ ]|-|[()]){0,2}9[1|2|3|4]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/
      ),
      { message: "phone_number_incorrect_error" }
    ),
});

export type AccountFormFields = z.infer<typeof accountSchema>;
